import cacheLs from "../cacheLs"

export default {
  addCareer (state, data) {
    state.selectedCareer = { ...data }
    cacheLs.set_career(data)
  }
}
